import { NavLink } from 'react-router-dom';

import { cn } from '@/lib/utils';

const TABS = [
  { to: '/hrm/recruitment', label: 'Openings', end: true },
  { to: '/hrm/recruitment/candidates', label: 'Candidates' },
  { to: '/hrm/recruitment/interviews', label: 'Interviews' },
  { to: '/hrm/recruitment/offers', label: 'Offers' },
];

/** Shared header row with sub-tabs for the Recruitment area. */
export function RecruitmentTabs() {
  return (
    <div className="border-b">
      <nav className="-mb-px flex flex-wrap gap-2" aria-label="Recruitment sections">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              cn(
                'border-b-2 px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'border-primary text-foreground'
                  : 'text-muted-foreground hover:text-foreground border-transparent',
              )
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
